import template 		from "../html/view-logs.html";
import css			from "../css/view-logs.css";

import moment			from "moment";
import sleep			from "sleep";

import {Icon}			from "gui";
import {Label}			from "gui";
import {Groupbox}		from "gui";
import DataTable		from "datatable";

class ViewLogs extends Groupbox {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-view-logs", ViewLogs);
  }
  async connectedCallback() {
    await super.connectedCallback();

    if (this.designerMode) return;
    /*
      we add event handlers/observers here in the constructor 
      and we don't have to remove the event listeners/observers because:

      If the element being observed is removed from the DOM, 
      and then subsequently released by the browser's garbage collection mechanism, 
      the MutationObserver is likewise deleted.    
    */

    await this.loadlogs("", -20);

    /* TODO: its rather ugly to access internal elements */
    this.datatableLogs.scrollwrap.scrollTop =  this.datatableLogs.scrollwrap.scrollHeight;
    
    this.iconBulb.style.display="none";

    /* keep the logs up to date    */
    this.onlog_handler_f = this.onlog_handler.bind(this);
    document.addEventListener("onlog", this.onlog_handler_f);

    /* we use mutation observers to enforce maxmimum 20 logs to be displayed */
    const config = { attributes: false, childList: true, subtree: true };
    this.mutationObserver = new MutationObserver(this.onmutation_handler.bind(this));
    this.mutationObserver.observe(this.datatableLogs, config);        

  }
  disconnectedCallback() {
    super.disconnectedCallback();

    this.mutationObserver.disconnect();
    document.removeEventListener("onlog", this.onlog_handler_f);
  }
  constructor(p) {
    super(p);    

    /* after login we load 20 logs */
    //document.addEventListener("onauthenticated", this.loadlogs.bind(this, "", 20));    

    this.userscroll = true;
    this.datatableLogs.scrollwrap.addEventListener("scroll", this.datatableLogs_scroll.bind(this));
  }
  onmutation_handler() {
    /*
    while (this.datatableLogs.children.length>20) {      
      this.datatableLogs.children[1].remove();
    }
    */
  }
  async loadlogs(cursor, num) {
    /* query logs logs */    
    var logs = await server.rcall("RM_syslog_getlogs", cursor, num);

    var content = this.datatableLogs.scrollwrap;

    var curScrollPos = content.scrollTop;
    var oldScroll = content.scrollHeight - content.clientHeight;

    /* append logs to the datatable */
    for await (const log of logs) {
      var row = new DataTable.Row();
      row.appendChild( new Icon({
        context: "status",
        size: 16,
        iconname: {
          debug: "dialog-information",
          info: "dialog-information",
          warning: "dialog-warning",
          err: "dialog-error"
        }[log.PRIORITY],
        style: "width: 22px"
      }) );
      row.appendChild( new Label({value: moment(log.ISODATE, moment.ISO_8601).format("YYYY-MM-DD HH:mm:ss"), style: "width: 15em;"}) );
      row.appendChild( new Label({value: log.MESSAGE}) );
      row.setAttribute("data-cursor", log.cursor);

      if (Math.sign(num)>0) {
        this.datatableLogs.appendChild( row );
      } else {
        if (this.datatableLogs.children.length>1) {
          this.datatableLogs.insertBefore(row, this.datatableLogs.children[1]);
        } else {
          this.datatableLogs.appendChild( row );
        }
      }

    } //for

    if (Math.sign(num)<0) {
      var newScroll = content.scrollHeight - content.clientHeight;
      content.scrollTop = curScrollPos + (newScroll - oldScroll);
    }

    if (Math.sign(num)>0) {
      while (this.datatableLogs.children.length>100)   
        this.datatableLogs.children[1].remove();
    } else {
      while (this.datatableLogs.children.length>100)   
        this.datatableLogs.lastElementChild.remove();      
    }    
    
    return logs.length;
  }
  async onlog_handler(event) {
    
    /* 
      if the console is not scrolled down to the bottom we do not add new logs
      user is searching earlier logs
      but we signal the there are new logs with a simple icon      
    */
    if (this.datatableLogs.scrollwrap.scrollTop<(this.datatableLogs.scrollwrap.scrollHeight-this.datatableLogs.scrollwrap.offsetHeight-1)) {
      this.iconBulb.style.display="";
      return;
    }
    
    await this.datatableLogs_scroll();

    /*
    var log = event.detail;
    
    this.userscroll = false;

    var row = new DataTable.Row();
    row.appendChild( new Icon({
      context: "status",
      size: 16,
      iconname: {
        debug: "dialog-information",
        info: "dialog-information",
        warning: "dialog-warning",
        err: "dialog-error"
      }[log.PRIORITY],
      style: "width: 22px"
    }) );
    row.appendChild( new Label({value: moment(log.ISODATE, moment.ISO_8601).format("YYYY-MM-DD HH:mm:ss"), style: "width: 15em;"}) );
    row.appendChild( new Label({value: log.MESSAGE}) );
    row.setAttribute("data-cursor", log.cursor);

    this.datatableLogs.appendChild( row );
    */
        
    /* TODO: its rather ugly to access internal elements */
    
    this.datatableLogs.scrollwrap.scrollTop = this.datatableLogs.scrollwrap.scrollHeight;  
    
    //this.userscroll = true;
  }
  async datatableLogs_scroll() {  
    if (!this.userscroll) return;
    
    if (this.datatableLogs.scrollwrap.scrollTop==0) {
      await this.loadlogs(this.datatableLogs.children[1].getAttribute("data-cursor"), -20);
    }
    //console.log(this.datatableLogs.scrollwrap.scrollTop, this.datatableLogs.scrollwrap.scrollHeight, this.datatableLogs.scrollwrap.offsetHeight);
    if (this.datatableLogs.scrollwrap.scrollTop>=(this.datatableLogs.scrollwrap.scrollHeight-this.datatableLogs.scrollwrap.offsetHeight-1)) {
      var n = await this.loadlogs(this.datatableLogs.lastElementChild.getAttribute("data-cursor"), 20);
      if (!n) this.iconBulb.style.display="none";
    }    
  }
}

ViewLogs.constructor();

export default ViewLogs;